import { render, staticRenderFns } from "./detailsTemplate.vue?vue&type=template&id=3094f9bc&scoped=true"
import script from "./detailsTemplate.vue?vue&type=script&lang=js"
export * from "./detailsTemplate.vue?vue&type=script&lang=js"
import style0 from "./detailsTemplate.vue?vue&type=style&index=0&id=3094f9bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3094f9bc",
  null
  
)

export default component.exports